import { useId, useState, type FormEvent } from 'react';
import { useLocale } from '../i18n/locale';
import { startIntake } from '../content/start';

/**
 * Starts the intake (same locale) from the HOME: the text travels in session storage (never in the
 * URL) and the intake opens on its first step with it. An empty field still opens the intake.
 */
export function RequestForm({ label, placeholder, action, value, onChange, labelHidden = false }: {
  label: string; placeholder: string; action: string; value?: string; onChange?: (value: string) => void; labelHidden?: boolean;
}) {
  const { locale } = useLocale();
  const id = useId(); const [own, setOwn] = useState('');
  const text = value ?? own; const set = onChange ?? setOwn;
  const submit = (event: FormEvent) => {
    event.preventDefault(); startIntake(locale, { need: text, start: '' });
  };
  return (
    <form className="request" onSubmit={submit}>
      <label className={labelHidden ? 'visually-hidden' : 'request__label'} htmlFor={id}>{label}</label>
      <div className="request__row">
        <textarea id={id} className="request__field" rows={2} value={text} placeholder={placeholder} maxLength={2000}
          onChange={event => set(event.target.value)} onKeyDown={event => { if (event.key === 'Enter' && !event.shiftKey) { event.preventDefault(); event.currentTarget.form?.requestSubmit(); } }} />
        <button type="submit" className="cta cta--primary request__submit">{action}</button>
      </div>
    </form>
  );
}
